import React from 'react';
import { ChevronRight } from 'lucide-react';
export interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}
interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}
export function Breadcrumbs({
  items,
  className = ''
}: BreadcrumbsProps) {
  return <nav className={`flex text-sm text-slate-500 ${className}`} aria-label="Breadcrumb" data-id="element-17720">
      <ol className="inline-flex items-center space-x-1 md:space-x-2" data-id="element-17721">
        {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return <li key={index} className="inline-flex items-center" data-id="element-17722">
              {index > 0 && <ChevronRight className="w-4 h-4 mx-1 text-slate-400" data-id="element-17723" />}
              {isLast ? <span className="text-slate-900 font-medium" aria-current="page" data-id="element-17724">
                  {item.label}
                </span> : <button onClick={item.onClick} className="hover:text-primary transition-colors focus:outline-none focus:underline" data-id="element-17725">
                  {item.label}
                </button>}
            </li>;
      })}
      </ol>
    </nav>;
}